import { Component } from '@angular/core';
import { SideNavCollection } from '@aveva/connect-web-core';

@Component({
  selector: 'app-root-component',
  templateUrl: './root.component.html'
})
export class RootComponent {
  links: SideNavCollection[] = [{
    label: 'Maintenance',
    icon: 'maintenance',
    routerLink: ['./maintenance']
  }];
}
